<template>
  <div>
    <div
      id="content"
      v-on:keyup="keymonitor"
      class="content animated slideInRight delay-1s"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Resetar senha de {{ users.name }}</div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form id="form">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="description">
                            <span class="required">*</span> Nova senha:
                          </label>
                          <input
                            :type="fieldTypes.password"
                            class="form-control"
                            id="pswd"
                            value=""
                            v-on:keyup="verifyPassword('pswd')"
                            v-model="users.new_password"
                            autocomplete="new-password"
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="description">
                            <span class="required">*</span> Corfirme a nova
                            senha:
                          </label>
                          <input
                            :type="fieldTypes.password_confirm"
                            class="form-control"
                            id="pswd"
                            v-on:keyup="verifyPassword('pswd')"
                            v-model="users.password_confirmation"
                            placeholder
                            autocomplete="new-password"
                          />
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div v-if="comparePassword()" class="left">
                          <div class="alert alert-danger col-md-3" role="alert">
                            <strong>As senhas não podem ser diferentes!</strong>
                          </div>
                        </div>
                        <div v-if="activatedCaps" class="left">
                          <label>
                            <span class="caps"
                              >CapsLock Ativo
                              <i
                                class="fa fa-arrow-circle-up"
                                aria-hidden="true"
                              ></i
                            ></span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div id="message" style="margin-top: 15px">
                          <h6>
                            Sua senha precisa conter pelo menos um dos itens
                            abaixo:
                          </h6>
                          <p id="letterpswd" class="invalid">
                            Uma <b>letra</b> minúscula
                          </p>
                          <p id="capitalpswd" class="invalid">
                            Uma <b>letra</b> maiúscula
                          </p>
                          <p id="numberpswd" class="invalid">
                            Um <b>número</b>
                          </p>
                          <p id="lengthpswd" class="invalid">
                            Mínimo de <b>8 caracteres</b>
                          </p>
                          <p id="charpswd" class="invalid">
                            Um
                            <b>caracter especial (@$!%*#?&-)</b>
                          </p>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div class="block text-right">
                      <button
                        type="button"
                        class="btn btn-add"
                        :disabled="
                          disabled &&
                          users.new_password != users.password_confirmation
                        "
                        @click="save"
                      >
                        <i class="fa fa-save"></i> Alterar Senha
                      </button>
                      <router-link to="/users" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fieldTypes: {
        password: "text",
        password_confirm: "text",
      },
      users: {
        name: "",
        new_password: "",
        password_confirmation: "",
      },
      disabled: true,
      activatedCaps: false,
    };
  },
  mounted() {
    const self = this;
    let id = self.$route.params.id;
    console.log("id", id);
    if (id) {
      self.getUsers(id);
    }
  },
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      fd.append("password", self.users.new_password);
      fd.append("password_confirm", self.users.password_confirmation);
      fd.append("id", self.$route.params.id);

      return fd;
    },
    verifyPassword(id) {
      const self = this;
      /*

    EU SEI QUE ISSO TÁ FEIO E RIDICULO, UMA HORA EU ARRUMO

    */
      if (this.users.new_password.length > 5) {
        this.fieldTypes.password = "password";
      } else {
        this.fieldTypes.password = "text";
      }

      if (this.users.password_confirmation.length > 5) {
        this.fieldTypes.password_confirm = "password";
      } else {
        this.fieldTypes.password_confirm = "text";
      }

      var myInput = document.getElementById(id);
      var letter = document.getElementById("letter" + id);
      var capital = document.getElementById("capital" + id);
      var capital = document.getElementById("capital" + id);
      var number = document.getElementById("number" + id);
      var length = document.getElementById("length" + id);
      var char = document.getElementById("char" + id);
      var count = 0;

      myInput.onkeyup = function () {
        var lowerCaseLetters = /[a-z]/g;
        if (myInput.value.match(lowerCaseLetters)) {
          letter.classList.remove("invalid");
          letter.classList.add("valid");
          letter.status = "valid";
        } else {
          letter.classList.remove("valid");
          letter.classList.add("invalid");
          letter.status = "invalid";
        }
        var upperCaseLetters = /[A-Z]/g;
        if (myInput.value.match(upperCaseLetters)) {
          capital.classList.remove("invalid");
          capital.classList.add("valid");
          capital.status = "valid";
        } else {
          capital.classList.remove("valid");
          capital.classList.add("invalid");
          capital.status = "invalid";
        }
        var numbers = /[0-9]/g;
        if (myInput.value.match(numbers)) {
          number.classList.remove("invalid");
          number.classList.add("valid");
          number.status = "valid";
        } else {
          number.classList.remove("valid");
          number.classList.add("invalid");
          number.status = "invalid";
        }

        var chars = /[@$!%*#?&-]/g;
        if (myInput.value.match(chars)) {
          char.classList.remove("invalid");
          char.classList.add("valid");
          char.status = "valid";
        } else {
          char.classList.remove("valid");
          char.classList.add("invalid");
          char.status = "invalid";
        }

        if (myInput.value.length >= 8) {
          length.classList.remove("invalid");
          length.classList.add("valid");
          length.status = "valid";
        } else {
          length.classList.remove("valid");
          length.classList.add("invalid");
          length.status = "invalid";
        }
        if (
          number.status == "valid" &&
          letter.status == "valid" &&
          capital.status == "valid" &&
          length.status == "valid" &&
          char.status == "valid"
        ) {
          self.disabled = false;
        } else {
          self.disabled = true;
        }
      };
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "user-reset-password";

      let fd = self.makeFormData();

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/users");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    keymonitor() {
      if (event.getModifierState && event.getModifierState("CapsLock")) {
        this.activatedCaps = true;
      } else {
        this.activatedCaps = false;
      }
      console.log(this.activatedCaps);
    },
    comparePassword: function () {
      if (this.users.new_password != this.users.password_confirmation || null)
        return [];
    },
    getUsers: function (id) {
      const self = this;
      const api = self.$store.state.api + "users/" + id;

      self.$http
        .get(api)
        .then((response) => {
          self.user = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
};
</script>

<style>
.comparePassword {
  color: rgb(241, 0, 0);
  font: bold;
  font-size: 20px;
}
.caps {
  color: black;
  font: bold;
  text-align: right;
  font-size: 20px;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}

/* Add a green text color and a checkmark when the requirements are right */
.valid {
  color: green;
}

.valid:before {
  position: relative;
  left: 0px;
  margin-right: 5px;
  content: "✔";
}

/* Add a red text color and an "x" when the requirements are wrong */
.invalid {
  color: red;
}

.invalid:before {
  position: relative;
  left: 0px;
  margin-right: 5px;
  content: "✖";
}
</style>


// WEBPACK FOOTER //
// src/components/User/Reset.vue